import { Inject } from '@odinjs/odin';
import { TabControlAPI, TabWithContentAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnMount, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { FragmentNames, IntakesAndOutputsAliases } from '../../codegen';
import { ApplicationRoute } from '../../constants/routes';
import { FoundationUtils } from '../../utils/foundation-utils';
import { FunctionName, PEP_9127Parameters } from '../../utils/parameters';
import BaseController from '../BaseController';
import InformationBarUtils from '../commons/header/information-bar-header-utils';
import { IntakesAndPutsContext } from './intakes-and-outputs-service';

enum Screen {
  INTAKES_AND_OUTPUT ='intakes-outputs',
  HYDRIC_BALANCE = 'hydric'
}

@Controller({ component: IntakesAndOutputsAliases.INTAKES_AND_OUTPUTS_LAYOUT, fragment: FragmentNames.INTAKES_AND_OUTPUTS })
export default class IntakesAndOutputsRootController extends BaseController {
  @Inject(IntakesAndOutputsAliases.TAB_CONTROL)
  tabControlApi!: TabControlAPI;

  @OnMount({ target: IntakesAndOutputsAliases.INTAKES_AND_OUTPUTS_LAYOUT })
  onMount(): void {
    const { screen, encounterId, patientId } = this.historyService.getCurrentRouteParams();
    InformationBarUtils.collapsedBar = true;
    IntakesAndPutsContext.clean(true);

    this.context.set({ encounterId, patientId });

    if(screen === Screen.HYDRIC_BALANCE) {
      this.tabControlApi.setActiveTab(String(screen))
    }
  }

  @OnMount(IntakesAndOutputsAliases.TAB_WITH_CONTENT_INTAKES_OUTPUTS)
  onMountIntakesOutputsTab(event: MountEvent): void {
    const isAllowed = FoundationUtils.findModuleParam(FunctionName.PEP_9127, PEP_9127Parameters.ALLOW_ACCESS_INTAKES_AND_OUTPUTS) as string;
    const tabApi = event.target as TabWithContentAPI;
    tabApi.setVisible(isAllowed === 'S')
  }

  @OnMount(IntakesAndOutputsAliases.TAB_WITH_CONTENT_HYDRIC_BALANCE)
  onMountHydricBalanceTab(event: MountEvent): void {
    const isAllowed = FoundationUtils.findModuleParam(FunctionName.PEP_9127, PEP_9127Parameters.ALLOW_ACCESS_HYDRIC_BALANCE) as string;
    const tabApi = event.target as TabWithContentAPI;
    tabApi.setVisible(isAllowed === 'S')
  }

  @OnMount(IntakesAndOutputsAliases.TAB_CONTROL)
  onMountTabControll(event: MountEvent): void {
    const tabApi = event.target as TabControlAPI;
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const isAllowedHydricBalance = (FoundationUtils.findModuleParam(FunctionName.PEP_9127, PEP_9127Parameters.ALLOW_ACCESS_HYDRIC_BALANCE) as string) === 'S';
    const isAllowedIntakes = (FoundationUtils.findModuleParam(FunctionName.PEP_9127, PEP_9127Parameters.ALLOW_ACCESS_INTAKES_AND_OUTPUTS) as string) === 'S';

    if (!isAllowedHydricBalance && !isAllowedIntakes) {
      applicationContext.redirect(ApplicationRoute.ELECTRONIC_PATIENT_CHART_DETAIL, {
        encounterId,
        patientId,
      });
      return;
    }

    if(isAllowedIntakes) {
      tabApi.setActiveTab('intakes');
    } else {
      tabApi.setActiveTab('hydric')
    }
  }

  @OnUnmount(IntakesAndOutputsAliases.INTAKES_AND_OUTPUTS_LAYOUT)
  onUnmountRoot(): void {
    IntakesAndPutsContext.clean(false);
  }
}
